import { Trans } from 'react-i18next';
import { ReactElement } from 'react';

import { getLocalizationFromAvailable } from 'helpers/localization';
import { getFaqLink } from 'helpers/getFaqLink';

import { Box, Text, Image } from 'libComponents';

import styles from './FooterWithPolicy.module.css';

import logo from './img/Logo.png';

import { LINKS } from './config';

function FooterWithPolicy(): ReactElement {
    const lang = getLocalizationFromAvailable();

    return (
        <Box paddingX={64} className={styles.footerBox} paddingTop={30} paddingBottom={32}>
            <div className={styles.logoWrapper}>
                <Image isForceVisible src={logo} maxWidth={107} alt="logo" />
            </div>
            {LINKS.map((link, index) => (
                <Text
                    center
                    key={index}
                    type="small-text"
                    mb={24}
                    className={styles.footerLink}
                    color="text-secondary-subdued"
                >
                    <a target="_blank" rel="noopener noreferrer" href={link.link}>
                        <Trans>{link.title}</Trans>
                    </a>
                </Text>
            ))}
            <Text type="small-text" color="text-secondary-subdued" center>
                <a target="_blank" rel="noopener noreferrer" href={getFaqLink(lang)}>
                    <Trans i18nKey="basics.faq" />
                </a>
            </Text>
        </Box>
    );
}

export default FooterWithPolicy;
